module.exports = __webpack_public_path__ + "img/40_69_002_060.1e34be3e.jpg";